import EnterpriseAdminDetails from '@/types/enterprise-admin-details';
import { addToArray, removeFromArray } from '../../../../utils/immutability';
import { AsyncResult, ApiAction, Action } from '../../../index';
import api from '../../../redux-api';
import { ReduxState } from '../../types';
import EnterpriseMember from '@/types/enterprise-member';

export const ADD_ENTERPRISE_MEMBER: ApiAction = {
  type: 'connect/enterprises/add-member',
  endpoint: 'enterprises/:id/members',
};

export const MODIFY_ENTERPRISE_MEMBER: ApiAction = {
  type: 'connect/enterprises/update-member',
  endpoint: 'enterprises/:id/members/:userId/',
};

export const DELETE_ENTERPRISE_MEMBER: ApiAction = {
  type: 'connect/enterprises/delete-member',
  endpoint: 'enterprises/:id/members/:userId/',
};

// Reducer
export default function reducer(state: EnterpriseAdminDetails, action: Action): EnterpriseAdminDetails {
  if (state === null) {
    return null;
  }

  switch (action.type) {
    // Enterprise group is always first, so use that one when adding a member to the enterprise
    // TODO -- get the actual response data format
    case `${ADD_ENTERPRISE_MEMBER.type}_SUCCESS`: {
      return {
        ...state,
        groups: [
          {
            ...state.groups[0],
            members: addToArray(state.groups[0].members, action.data),
          },
          ...state.groups.slice(1),
        ],
      };
    }

    case `${MODIFY_ENTERPRISE_MEMBER.type}_SUCCESS`: {
      return {
        ...state,
        groups: state.groups.map(group => ({
          ...group,
          members: group.members.map(member => {
            if (member._id === action.data.userId) {
              return {
                ...member,
                uid: action.data.uid,
                nameId: action.data.nameId,
              };
            }
            return member;
          }),
        })),
      };
    }

    case `${DELETE_ENTERPRISE_MEMBER.type}_SUCCESS`: {
      return {
        ...state,
        groups: state.groups.map(group => ({
          ...group,
          members: removeFromArray(group.members, action.params.userId),
        })),
      };
    }

    default: {
      return state;
    }
  }
}

const getCurrentEnterpriseId = (state: ReduxState) => {
  const { details } = state.enterprise;
  return details ? details._id : null;
};

export const addEnterpriseMember =
  (fname: string, lname: string, email: string, uid: string, nameId: string): AsyncResult<EnterpriseMember> =>
  (dispatch, getState) => {
    const id = getCurrentEnterpriseId(getState());
    return api.post(ADD_ENTERPRISE_MEMBER, { id }, { fname, lname, email, uid, nameId });
  };

export const modifyEnterpriseMember =
  (userId: string, uid: string, nameId: string): AsyncResult<void> =>
  (dispatch, getState) => {
    const id = getCurrentEnterpriseId(getState());
    return api.patch(MODIFY_ENTERPRISE_MEMBER, { id, userId }, { uid, nameId });
  };

export const deleteEnterpriseMember =
  (userId: string): AsyncResult<void> =>
  (dispatch, getState) => {
    const id = getCurrentEnterpriseId(getState());
    return api.delete(DELETE_ENTERPRISE_MEMBER, { id, userId });
  };
